import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { danhSachKhongDuDieuKienThucTapApi } from "../../../api/xet-thuc-tap/danhSachKhongDuDieuKienThucTapApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eDanhSachKhongDuDieuKienThucTapActionIds, IDanhSachKhongDuDieuKienThucTapActionTypes } from "../../action-types/xet-thuc-tap/IDanhSachKhongDuDieuKienThucTapActions";
import { rootActions } from "../../actions/rootActions";

export function* danhSachKhongDuDieuKienThucTapSaga(): any {
    yield takeLatest(eDanhSachKhongDuDieuKienThucTapActionIds.LOAD_BY_DOT_THUC_TAP_START, loadByDotXetWorker);
    yield takeLatest(eDanhSachKhongDuDieuKienThucTapActionIds.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START, loadByDotChiTietDiemWorker);
    yield takeEvery(eDanhSachKhongDuDieuKienThucTapActionIds.CHUYEN_DU_DIEU_KIEN_START, chuyenDuDieuKienWorker);
}

function* chuyenDuDieuKienWorker(action: IDanhSachKhongDuDieuKienThucTapActionTypes): any {
    const payload = action.payload as { id: number, id_dot_thuc_tap: number };
    const response: IBaseResponse = yield call(danhSachKhongDuDieuKienThucTapApi.ChuyenDuDieuKien, payload.id);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.CHUYEN_DU_DIEU_KIEN_SUCCESS(undefined));
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START(payload.id_dot_thuc_tap));
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START(payload.id_dot_thuc_tap));
    } else {
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.CHUYEN_DU_DIEU_KIEN_ERROR(response.message ?? "Lỗi khi chuyển sinh viên sang đủ điều kiện"));
    }
}

function* loadByDotXetWorker(action: IDanhSachKhongDuDieuKienThucTapActionTypes) {
    const id_dot_thuc_tap = action.payload as number;
    const response: IBaseResponse = yield danhSachKhongDuDieuKienThucTapApi.SelectByDotThucTap(id_dot_thuc_tap);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_ERROR(response.message ?? "Lỗi khi tải danh sách không đủ điều kiện thực tập"));
    }
}

function* loadByDotChiTietDiemWorker(action: IDanhSachKhongDuDieuKienThucTapActionTypes) {
    const id_dot_thuc_tap = action.payload as number;
    const response: IBaseResponse = yield danhSachKhongDuDieuKienThucTapApi.SelectByDotThucTapChiTietDiem(id_dot_thuc_tap);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_SUCCESS({
            danhSachKhongDuDieuKiens: toLowerCaseDeep(response.data.danhSachKhongDuDieuKiens),
            diemXets: toLowerCaseDeep(response.data.diemXets)
        }));
    } else {
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR(response.message ?? "Lỗi khi tải chi tiết điểm thực tập"));
    }
}